import { useState } from 'react'

import type { ValidationPreview } from './types'

export interface ConfirmState {
	data: Partial<ValidationPreview>
	id: null | string
	status: boolean
}

const EMPTY_CONFIRM: ConfirmState = {
	data: {},
	id: null,
	status: false
}

function useConfirmState() {
	const [state, set] = useState(EMPTY_CONFIRM)
	const reset = () => set(EMPTY_CONFIRM)

	return {
		reset,
		set,
		state
	}
}

export { EMPTY_CONFIRM, useConfirmState }
